import { ContactForm } from "@/components/contact/ContactForm";
import type { ContactPayload } from "@/lib/api-types";
import { cn } from "@/lib/utils";

interface ContactGlassFormCardProps {
  source?: ContactPayload["source"];
  className?: string;
  title?: string;
}

export function ContactGlassFormCard({
  source = "contact",
  className,
  title = "Send us a Message",
}: ContactGlassFormCardProps) {
  return (
    <div
      id="contact-form"
      className={cn("contact-glass scroll-mt-28 p-8 md:p-10", className)}
    >
      <h2 className="text-xl font-bold text-[var(--contact-text)] md:text-2xl">
        {title}
      </h2>
      <p className="mt-2 text-sm text-[var(--contact-muted)]">
        We typically respond within 2 business days.
      </p>
      <div className="mt-6">
        <ContactForm source={source} variant="premium" />
      </div>
    </div>
  );
}
